import { appCustomer } from './customer/default/appCustomer.constants';

export { COLOR_LOCKED } from './customer/default/icon.constants';

/**
 * @typedef {string} IconType
 */

/**
 * @enum {IconType}
 */
export const ICON_TYPE = {
  SERVICE_ICON: 'service-icon',
  SIMPLE_ICON: 'icon',
};

export const customerServiceIcon = {
  type: ICON_TYPE.SERVICE_ICON,
  name: appCustomer,
};

export const ICON_COLOR_SUFFIX = {
  dark: '_dark',
  default: '',
  light: '_ghost',
};
